import create from 'zustand';
import { MinistryTeam } from '../screens/report/screen/vision2028/types/ministryTeam';

interface MinistryTeamStoreState {
  ministryTeams: MinistryTeam[];

  // 액션
  addMinistryTeam: (ministryTeam: MinistryTeam) => void;
  removeMinistryTeam: (index: number) => void;
  setMinistryTeams: (ministryTeams: MinistryTeam[]) => void;
  clearMinistryTeams: () => void;
}

/**
 * 사역팀 관리 스토어
 * 월간 보고서와 완전히 별개로 관리되는 사역팀 리스트
 */
export const useMinistryTeamStore = create<MinistryTeamStoreState>((set) => ({
  ministryTeams: [],

  /**
   * 사역팀 추가 (추가 후 이름별로 정렬)
   */
  addMinistryTeam: (ministryTeam) => {
    set((state) => {
      const list = [...state.ministryTeams, ministryTeam];

      // 이름으로 정렬
      list.sort((a, b) => a.name.localeCompare(b.name, 'ko'));

      return { ministryTeams: list };
    });
  },

  /**
   * 사역팀 삭제
   */
  removeMinistryTeam: (index) => {
    set((state) => ({
      ministryTeams: state.ministryTeams.filter((_, i) => i !== index),
    }));
  },

  /**
   * 사역팀 리스트 전체 설정
   */
  setMinistryTeams: (ministryTeams) => set({ ministryTeams }),

  /**
   * 사역팀 리스트 초기화
   */
  clearMinistryTeams: () => set({ ministryTeams: [] }),
}));
